import React from "react";
import "./styles.less";

export const Title = (props) => {
  const { children, title, align = "center" } = props;
  return (
    <div className="authing-new-title-wrapper">
      <h3 className="title" style={{ textAlign: align }}>
        {title}
      </h3>
      {children && <div className="description">{children}</div>}
    </div>
  );
};
